
import * as handlebars_family from "../handlebars_family.ts";
import "../widget/action-menu.ts";
const TPL = handlebars_family.addTemplate("mealplanner/modal_recipecategories_item",{"1":function(container,depth0,helpers,partials,data) {
    return "draggable=\"true\"";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"flexcenter\" data-widget=\"widget/action-menu\" data-key=\"emojifood\"><input name=\"emoji\" data-type=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "\" type=\"hidden\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "\"><emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji></span> ";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji> ";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <input class=\"flexauto ghost\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"unless","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":477},"end":{"line":1,"column":524}}})) != null ? stack1 : "")
    + " name=\"name\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"computedName") : depth0), depth0))
    + "\"> ";
},"8":function(container,depth0,helpers,partials,data) {
    return "readonly";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexauto>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"computedName") : depth0), depth0))
    + "</flexauto> ";
},"12":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"recipecatdelete\" class=\"color-branded\" style=\"display:none\"> "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_delete_circle",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":731},"end":{"line":1,"column":761}}}))
    + " </icon> ";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"recipecatclick\"> "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_drag",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":843},"end":{"line":1,"column":864}}}))
    + " </icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":5},"end":{"line":1,"column":52}}})) != null ? stack1 : "")
    + " class=\"recipecategoryedit\" style=\"padding:4px 0\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><flexrow class=\"border-pane\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":163},"end":{"line":1,"column":421}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":1,"column":422},"end":{"line":1,"column":621}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canDelete") : stack1),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":622},"end":{"line":1,"column":777}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":778},"end":{"line":1,"column":880}}})) != null ? stack1 : "")
    + " </flexrow></div>";
},"useData":true});
export default TPL;